/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleDataProviderResourceData
 */
export interface GoogleDataProviderResourceData {
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    resourceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    providerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    parentDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    timeZone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleDataProviderResourceData
     */
    maximumBytesBilled?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleDataProviderResourceData
     */
    dailyBytesLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleDataProviderResourceData
     */
    monthlyBytesLimit?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleDataProviderResourceData
     */
    propertyTimeZone?: string | null;
    /**
     * 
     * @type {GoogleDataProviderResourceDataBigQueryRecipeStatusEnum}
     * @memberof GoogleDataProviderResourceData
     */
    bigQueryRecipeStatus?: GoogleDataProviderResourceDataBigQueryRecipeStatusEnum | null;
}


/**
 * @export
 */
export const GoogleDataProviderResourceDataBigQueryRecipeStatusEnum = {
    PendingEventsExport: 'pending-events-export',
    Ready: 'ready'
} as const;
export type GoogleDataProviderResourceDataBigQueryRecipeStatusEnum = typeof GoogleDataProviderResourceDataBigQueryRecipeStatusEnum[keyof typeof GoogleDataProviderResourceDataBigQueryRecipeStatusEnum];


/**
 * Check if a given object implements the GoogleDataProviderResourceData interface.
 */
export function instanceOfGoogleDataProviderResourceData(value: object): value is GoogleDataProviderResourceData {
    return true;
}

export function GoogleDataProviderResourceDataFromJSON(json: any): GoogleDataProviderResourceData {
    return GoogleDataProviderResourceDataFromJSONTyped(json, false);
}

export function GoogleDataProviderResourceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleDataProviderResourceData {
    if (json == null) {
        return json;
    }
    return {
        
        'resourceId': json['resourceId'] === undefined ? undefined : json['resourceId'] === null ? null : json['resourceId'],
        'providerId': json['providerId'] == null ? undefined : json['providerId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'parentDisplayName': json['parentDisplayName'] === undefined ? undefined : json['parentDisplayName'] === null ? null : json['parentDisplayName'],
        'timeZone': json['timeZone'] === undefined ? undefined : json['timeZone'] === null ? null : json['timeZone'],
        'currencyCode': json['currencyCode'] === undefined ? undefined : json['currencyCode'] === null ? null : json['currencyCode'],
        'maximumBytesBilled': json['maximumBytesBilled'] === undefined ? undefined : json['maximumBytesBilled'] === null ? null : json['maximumBytesBilled'],
        'dailyBytesLimit': json['dailyBytesLimit'] === undefined ? undefined : json['dailyBytesLimit'] === null ? null : json['dailyBytesLimit'],
        'monthlyBytesLimit': json['monthlyBytesLimit'] === undefined ? undefined : json['monthlyBytesLimit'] === null ? null : json['monthlyBytesLimit'],
        'propertyTimeZone': json['propertyTimeZone'] === undefined ? undefined : json['propertyTimeZone'] === null ? null : json['propertyTimeZone'],
        'bigQueryRecipeStatus': json['bigQueryRecipeStatus'] === undefined ? undefined : json['bigQueryRecipeStatus'] === null ? null : json['bigQueryRecipeStatus'],
    };
}

export function GoogleDataProviderResourceDataToJSON(json: any): GoogleDataProviderResourceData {
    return GoogleDataProviderResourceDataToJSONTyped(json, false);
}

export function GoogleDataProviderResourceDataToJSONTyped(value?: GoogleDataProviderResourceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resourceId': value['resourceId'],
        'providerId': value['providerId'],
        'displayName': value['displayName'],
        'parentDisplayName': value['parentDisplayName'],
        'timeZone': value['timeZone'],
        'currencyCode': value['currencyCode'],
        'maximumBytesBilled': value['maximumBytesBilled'],
        'dailyBytesLimit': value['dailyBytesLimit'],
        'monthlyBytesLimit': value['monthlyBytesLimit'],
        'propertyTimeZone': value['propertyTimeZone'],
        'bigQueryRecipeStatus': value['bigQueryRecipeStatus'],
    };
}

